import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const RefundPolicyPage = () => (
  <div className="legal-page">
    <div className="legal-container">
      <Link to="/" className="legal-back-link">← Back to Home</Link>

      <div className="legal-header">
        <span className="legal-eyebrow">Legal</span>
        <h1 className="legal-title">Refund Policy</h1>
        <p className="legal-updated">Last updated: 18 March 2026</p>
      </div>

      <div className="legal-body">
        <p>
          This Refund Policy applies to all payments made on the <strong>CodeHub</strong> platform operated by{' '}
          <strong>Batos IT Solutions LLP</strong>. Please read this policy carefully before making any payment.
        </p>

        <div className="legal-highlight">
          <strong>⚠️ No Refund Policy:</strong> All payments made on CodeHub are <strong>final and non-refundable</strong>.
          Once a payment is successfully processed, no refund will be issued under any circumstances.
        </div>

        <h2>1. Scope</h2>
        <p>This policy covers all fees paid for:</p>
        <ul>
          <li>Internship enrollment fees</li>
          <li>Project enrollment fees</li>
          <li>Any other services offered through the CodeHub platform</li>
        </ul>

        <h2>2. Why We Don't Offer Refunds</h2>
        <p>
          CodeHub provides digital educational services including project assignments, mentor reviews, and certificate issuance.
          Once you enroll:
        </p>
        <ul>
          <li>A project is immediately assigned to you</li>
          <li>Platform resources and mentor capacity are reserved for you</li>
          <li>You gain immediate access to project guidelines and submission tools</li>
        </ul>
        <p>
          Due to the nature of digital services and the immediate resource allocation, refunds are not applicable.
        </p>

        <h2>3. Payment Failures</h2>
        <ul>
          <li>If a payment fails during processing, no amount is deducted and no enrollment is created.</li>
          <li>If money is debited but the payment status shows "failed" on our platform, the amount will be automatically refunded by your bank or payment provider within <strong>5–7 business days</strong>.</li>
          <li>If the amount is not refunded within 7 business days, contact us with your transaction details.</li>
        </ul>

        <h2>4. Duplicate Payments</h2>
        <p>
          If you are charged twice for the same enrollment due to a technical issue, contact us with both transaction IDs.
          We will refund the duplicate payment within <strong>5–7 business days</strong> after verification.
        </p>

        <h2>5. Technical Issues</h2>
        <p>
          If you face any technical issues accessing the platform after payment, our support team will assist you in
          resolving the issue. Technical difficulties are not grounds for a refund.
        </p>

        <div className="legal-info">
          <strong>💡 Before You Pay:</strong> We encourage you to review the internship structure, project categories, 
          and all terms carefully before making a payment. You can also reach out to our support team for any
          pre-enrollment questions.
        </div>

        <h2>6. Exceptions</h2>
        <p>
          Refund exceptions may be considered <strong>solely at the discretion</strong> of Batos IT Solutions LLP
          in the following rare cases:
        </p>
        <ul>
          <li>A platform-wide technical failure preventing all enrolled users from accessing services for an extended period</li>
          <li>Accidental overcharge due to a system error (verified by our technical team)</li>
        </ul>
        <p>
          Any exception-based refund request must be raised within <strong>48 hours</strong> of payment by emailing{' '}
          <a href="mailto:support@batosit.com">support@batosit.com</a>.
        </p>

        <h2>7. Contact Us</h2>
        <p>For payment-related queries:</p>

        <div className="legal-contact">
          <h3>Batos IT Solutions LLP</h3>
          <p>
            Sterling Towers, Level 1, 2 & 3, Pan Card Club Road, Baner, Pune 411045<br />
            Email: <a href="mailto:support@batosit.com">support@batosit.com</a><br />
            Website: <a href="https://www.codehub.batosit.com">www.codehub.batosit.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default RefundPolicyPage;
